import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { CourseService } from '../../services/course.service';
import { DomSanitizer } from '@angular/platform-browser';
import { LtiService } from '../../../services/lti.service';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';

@Component({
    selector: 'app-htmldoc-modal',
    templateUrl: './htmldoc-modal.component.html',
    styleUrls: ['./htmldoc-modal.component.scss'],
    standalone: false
})
export class HtmldocModalComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    public dialogRef: ScaffoldDialogRef,
    private courseService: CourseService,
    private domSanitizer: DomSanitizer,
    private LTIService: LtiService
  ) {}
  content = false;
  data: any = {};
  error;
  lmss = [];
  lms;
  launch_url;
  @ViewChild('dialogContent', { static: false }) dialogConten: ElementRef;
  @ViewChild('iframe', { static: false }) iframe: ElementRef;
  iframeDoc;

  acceptSettings = {
    link: 'lti_launch_url,url,image_url',
  };

  ngOnInit() {
    this.launch();
    let option: AddEventListenerOptions = { once: true };
    if (window.addEventListener) {
      window.addEventListener(
        'message',
        this.receiveMessage.bind(this),
        option
      );
    } else {
      (<any>window).attachEvent('onmessage', this.receiveMessage.bind(this));
    }
  }
  ngOnDestroy() {
    if (window.addEventListener) {
      //window.removeEventListener("message", this.receiveMessage.bind(this), false);
    } else {
      (<any>window).detachEvent('onmessage', this.receiveMessage.bind(this));
    }
  }
  ngAfterViewInit() {
    const nativeEl = this.iframe.nativeElement;
    this.iframeDoc = nativeEl.contentWindow;
    //TEMP set z-index to above tinymce modal level for tinymce custom filebrowserj
    if (this.data.target_z) {
      this.dialogConten.nativeElement.closest(
        '.cdk-overlay-container'
      ).className += ' over-mce-dialog';
    }
  }

  receiveMessage(message) {
    console.log('message');
    console.log(message);
    if (message?.data?.lms) message.data.lms = this.lms;
    if (message?.data?.course) message.data.course = this.courseService.id;

    this.dialogRef.close(message?.data);
  }

  launch() {
    console.log(this.data);
    console.log(this.courseService);
    let course = this.courseService.data;
    let type;
    if (this.data.button) {
      type = this.data.button.message_type;
      this.launch_url = this.data.button.url;
    }
    if (!this.launch_url) {
      this.launch_url = this.data.tool.data.launch_url;
    }
    console.log(course);
    if (course && course.lms) {
      console.log(course.lms);
      this.lmss = course.lms.split(/\|/g);
      if (this.lmss.length === 1) {
        this.setLMS(this.lmss[0]);
      }
    } else {
      this.error = 'Course not found in LMS, please run a Sync to LMS';
    }
  }

  setLMS(lms) {
    this.lms = lms;
    let course = this.courseService.data;
    let type;
    if (this.data.button) {
      type = this.data.button.location_type;
    }
    console.log(lms);
    this.LTIService.initLaunch(
      this.data.tool.data,
      this.data.info,
      course,
      lms,
      type,
      this.acceptSettings[this.data.type]
    ).subscribe(e => {
      this.content = true;
      console.log('Launch Start');
      this.submitForm(e);
    });
  }

  submitForm(data) {
    let form = this.LTIService.generateForm(this.launch_url, 'POST', data);
    this.iframeDoc.document.body.appendChild(form);
    console.log(this.iframeDoc.document);
    console.log('submit form');
    try {
      form.submit();
    } catch (e) {
      console.log(e);
    }
    console.log('form submitted');
  }
}
